import React from 'react';
import { LogoFull } from './Logo';

var pageStyle = { maxWidth: 720, margin: '0 auto', padding: '40px 24px', fontFamily: "'Pretendard',sans-serif", color: '#333', lineHeight: 1.8, fontSize: 14 };
var h2Style = { fontSize: 17, fontWeight: 700, color: '#1B3A5C', margin: '28px 0 10px', borderLeft: '4px solid #1B3A5C', paddingLeft: 12 };
var ulStyle = { margin: '6px 0 12px', paddingLeft: 20 };
var header = function(title, sub) {
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: 32 }}><a href="/" style={{ textDecoration: 'none' }}><LogoFull iconSize={36} fontSize={24} /></a></div>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0f172a', textAlign: 'center', marginBottom: 8 }}>{title}</h1>
      <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, marginBottom: 32 }}>{sub}</p>
    </div>
  );
};
var footer = function() {
  return (
    <div style={{ marginTop: 48, paddingTop: 20, borderTop: '1px solid #e5e7eb', textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>
      <p>AUTODEX. All rights reserved.</p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 8 }}>
        <a href="/" style={{ color: '#3b82f6', textDecoration: 'none', fontSize: 13 }}>홈으로</a>
        <a href="/terms" style={{ color: '#64748b', textDecoration: 'none', fontSize: 13 }}>이용약관</a>
        <a href="/privacy" style={{ color: '#64748b', textDecoration: 'none', fontSize: 13 }}>개인정보처리방침</a>
      </div>
    </div>
  );
};

function Terms() {
  return (
    <div style={pageStyle}>
      {header('이용약관', '시행일: 2026년 4월 1일 | 최종 수정: 2026년 4월 9일')}

      <h2 style={h2Style}>제1조 (목적)</h2>
      <p>이 약관은 AUTODEX(이하 "회사")가 제공하는 AI 기반 중고차 수출 관리 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>

      <h2 style={h2Style}>제2조 (용어의 정의)</h2>
      <ul style={ulStyle}>
        <li><strong>"서비스"</strong>란 차량 등록, AI OCR 문서 인식, 서류 자동생성(매매계약서, 말소신청서, 인보이스 등), 세무 처리, 장부 관리, 차량 평가 등 중고차 수출 업무 자동화 서비스를 말합니다.</li>
        <li><strong>"이용자"</strong>란 이 약관에 동의하고 회사의 승인을 받아 서비스를 이용하는 개인 또는 법인을 말합니다.</li>
        <li><strong>"계정"</strong>이란 이용자가 서비스에 접속하기 위해 설정한 아이디와 비밀번호의 조합을 말합니다.</li>
      </ul>

      <h2 style={h2Style}>제3조 (약관의 효력 및 변경)</h2>
      <p>1. 이 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</p>
      <p>2. 회사는 필요한 경우 약관을 변경할 수 있으며, 변경된 약관은 시행일 7일 전에 공지합니다.</p>
      <p>3. 이용자가 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.</p>

      <h2 style={h2Style}>제4조 (서비스 가입 및 승인)</h2>
      <p>1. 이용자는 회사가 정한 가입 절차에 따라 필요한 정보를 제공하고 서비스에 가입합니다.</p>
      <p>2. 회사는 가입 신청을 검토한 후 승인 또는 거절할 수 있으며, 거절 시 사유를 안내합니다.</p>
      <p>3. 1인 1계정 원칙이며, 동일인이 복수 계정을 생성하는 것은 금지됩니다.</p>
      <p>4. 허위 정보로 가입하거나 타인의 정보를 도용한 경우 서비스 이용이 즉시 제한됩니다.</p>

      <h2 style={h2Style}>제5조 (서비스 이용)</h2>
      <p><strong>이용 요금:</strong> 서비스는 현재 무료로 제공되며, AI OCR 인식 횟수는 월 100건으로 제한됩니다.</p>
      <p><strong>유료 서비스 도입:</strong> 회사는 향후 일부 기능에 대해 유료 서비스 또는 수수료를 도입할 수 있으며, 이 경우 제3조에 따라 사전에 공지합니다. 무료 이용 중 등록한 데이터는 유료 서비스 도입 이후에도 유지됩니다.</p>
      <p><strong>서비스 시간:</strong> 서비스는 연중무휴 24시간 제공을 원칙으로 하며, 정기 점검 시 사전 공지합니다.</p>

      <h2 style={h2Style}>제6조 (이용자의 의무)</h2>
      <p>이용자는 다음 행위를 해서는 안 됩니다:</p>
      <ul style={ulStyle}>
        <li>타인의 계정을 무단으로 사용하거나 개인정보를 부정하게 수집하는 행위</li>
        <li>서비스를 통해 취득한 정보를 무단으로 제3자에게 제공하거나 상업적으로 이용하는 행위</li>
        <li>자동화된 수단(봇, 크롤러 등)을 이용하여 서비스에 접근하거나 데이터를 수집하는 행위</li>
        <li>서비스의 안정적 운영을 방해하거나 시스템에 부하를 주는 행위</li>
        <li>서비스를 이용하여 법령에 위반되는 행위를 하는 것</li>
        <li>회사의 지적재산권을 침해하는 행위</li>
      </ul>

      <h2 style={h2Style}>제7조 (서비스 중단 및 변경)</h2>
      <p>1. 회사는 시스템 점검, 장비 교체, 천재지변 등 불가피한 사유가 있는 경우 서비스를 일시 중단할 수 있으며, 가능한 사전에 공지합니다.</p>
      <p>2. 회사는 서비스의 기능을 추가, 변경, 중단할 수 있으며, 중요한 변경은 30일 전에 공지합니다.</p>

      <h2 style={h2Style}>제8조 (계약 해지 및 탈퇴)</h2>
      <p>1. 이용자는 언제든지 서비스 탈퇴를 요청할 수 있으며, 회사는 요청 접수 후 지체 없이 처리합니다.</p>
      <p>2. 탈퇴 시 이용자의 데이터는 관련 법령이 허용하는 범위 내에서 삭제됩니다.</p>
      <p>3. 회사는 이용자가 본 약관을 위반한 경우 사전 통지 후 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.</p>

      <h2 style={h2Style}>제9조 (면책)</h2>
      <p>1. 회사는 이용자가 서비스를 통해 생성한 서류의 법적 효력에 대해 보증하지 않으며, 이용자는 서류의 정확성을 직접 확인할 책임이 있습니다.</p>
      <p>2. 회사는 천재지변, 전쟁, 해킹, DDoS 공격 등 불가항력으로 인한 서비스 중단이나 데이터 손실에 대해 책임을 지지 않습니다.</p>
      <p>3. 이용자의 귀책사유로 인한 서비스 이용 장애에 대해 회사는 책임을 지지 않습니다.</p>

      <h2 style={h2Style}>제10조 (지적재산권)</h2>
      <p>서비스에 포함된 소프트웨어, 디자인, 로고, AI 모델 등 모든 지적재산권은 회사에 귀속됩니다. 이용자는 서비스 이용 과정에서 입력한 데이터에 대한 권리를 보유합니다.</p>

      <h2 style={h2Style}>제11조 (분쟁 해결)</h2>
      <p>서비스 이용과 관련한 분쟁은 대한민국 법을 적용하며, 관할 법원은 인천지방법원으로 합니다.</p>

      {footer()}
    </div>
  );
}

function Privacy() {
  return (
    <div style={pageStyle}>
      {header('개인정보처리방침', '시행일: 2026년 4월 1일 | 최종 수정: 2026년 4월 9일')}

      <h2 style={h2Style}>제1조 (수집하는 개인정보)</h2>
      <p>회사는 서비스 제공을 위해 다음 개인정보를 수집합니다:</p>
      <table style={{ width: '100%', borderCollapse: 'collapse', margin: '10px 0 16px', fontSize: 13 }}>
        <thead><tr style={{ background: '#f8fafc' }}>
          <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>구분</th>
          <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>수집 항목</th>
          <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>수집 방법</th>
        </tr></thead>
        <tbody>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>필수</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>아이디, 비밀번호(해시), 업체명, 대표자명</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>회원가입</td></tr>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>선택</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>전화번호, 이메일, 사업자등록번호, 사업자등록증 이미지</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>회원가입</td></tr>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>업무용</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>차량 소유자 성명, 주민등록번호, 주소</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>차량 등록/OCR</td></tr>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>자동수집</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>접속 IP, 접속 시간, 브라우저 정보</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>서비스 이용 시</td></tr>
        </tbody>
      </table>

      <h2 style={h2Style}>제2조 (수집 목적)</h2>
      <ul style={ulStyle}>
        <li>서비스 제공 및 회원 관리 (본인 확인, 계정 관리)</li>
        <li>수출 서류 자동생성 (매매계약서, 말소신청서, 인보이스 등)</li>
        <li>AI OCR 문서 인식 및 차량 데이터 추출</li>
        <li>세무 처리 및 장부 관리</li>
        <li>고객 문의 대응 및 서비스 개선</li>
      </ul>

      <h2 style={h2Style}>제3조 (보유 및 이용 기간)</h2>
      <p>1. 이용자의 개인정보는 <strong>서비스 이용 기간 동안</strong> 보유하며, 탈퇴 요청 시 지체 없이 파기합니다.</p>
      <p>2. 단, 관련 법령에 따라 보존이 필요한 경우 아래 기간 동안 보관합니다:</p>
      <ul style={ulStyle}>
        <li>전자상거래법 — 계약/청약 철회 기록: 5년</li>
        <li>통신비밀보호법 — 접속 로그: 3개월</li>
      </ul>
      <p>3. <strong>주민등록번호</strong>는 서류 생성 완료 후 DB에서 즉시 삭제되며, PDF 서류 내에만 보존됩니다.</p>

      <h2 style={h2Style}>제4조 (개인정보의 제3자 제공)</h2>
      <p>회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우 예외로 합니다:</p>
      <ul style={ulStyle}>
        <li>법령에 의한 수사기관의 요청이 있는 경우</li>
        <li>이용자가 사전에 동의한 경우</li>
      </ul>

      <h2 style={h2Style}>제5조 (개인정보 보호 조치)</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse', margin: '10px 0 16px', fontSize: 13 }}>
        <thead><tr style={{ background: '#f8fafc' }}>
          <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>항목</th>
          <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>보호 조치</th>
        </tr></thead>
        <tbody>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>주민등록번호</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>AES-256-CBC 암호화 저장, 화면 마스킹 (890801-*******)</td></tr>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>비밀번호</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>bcrypt 단방향 해시 저장 (복호화 불가)</td></tr>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>통신 구간</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>HTTPS(TLS 1.2+) 암호화</td></tr>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>접근 권한</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>역할 기반 접근 제어 (RBAC), JWT 인증</td></tr>
          <tr><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>파일 저장</td><td style={{ border: '1px solid #e5e7eb', padding: '8px 12px' }}>업체별 격리 (cross-tenant 접근 차단)</td></tr>
        </tbody>
      </table>

      <h2 style={h2Style}>제6조 (이용자의 권리)</h2>
      <p>이용자는 언제든지 다음 권리를 행사할 수 있습니다:</p>
      <ul style={ulStyle}>
        <li>개인정보의 조회, 수정, 삭제 요청</li>
        <li>개인정보 처리 정지 요청</li>
        <li>서비스 탈퇴 요청 (탈퇴 시 즉시 데이터 삭제)</li>
        <li>개인정보 처리에 대한 동의 철회</li>
      </ul>
      <p>권리 행사는 서비스 내 설정 메뉴 또는 이메일(support@autodex.kr)로 가능합니다.</p>

      <h2 style={h2Style}>제7조 (쿠키 및 자동 수집)</h2>
      <p>서비스는 세션 관리를 위한 JWT 토큰을 localStorage에 저장합니다. 이는 로그인 상태 유지를 위한 것이며, 별도의 추적 쿠키는 사용하지 않습니다.</p>

      <h2 style={h2Style}>제8조 (개인정보 보호 책임자)</h2>
      <div style={{ background: '#f8fafc', borderRadius: 8, padding: 16, margin: '10px 0' }}>
        <p style={{ margin: '4px 0' }}><strong>담당:</strong> 개인정보 보호 책임자</p>
        <p style={{ margin: '4px 0' }}><strong>이메일:</strong> support@autodex.kr</p>
        <p style={{ margin: '4px 0' }}><strong>접수:</strong> 개인정보 관련 문의 및 불만은 위 이메일로 접수해 주세요.</p>
      </div>
      <p>기타 개인정보 침해 신고 및 상담: 개인정보침해신고센터(privacy.kisa.or.kr), 대검찰청 사이버수사과(spo.go.kr)</p>

      {footer()}
    </div>
  );
}

export { Terms, Privacy };
